<template>
    <div>
        <b-modal v-model="modalResultVisible" hide-footer hide-header-close>
            <template #modal-title>
                Transfer Status
            </template>
            <div class="d-block text-center">
                <b-table-simple :items="transferredAcivities">
                    <b-thead head-variant="dark">
                        <b-tr>
                            <b-th>Reference No</b-th>
                            <b-th>Status</b-th>
                            <b-th>Link</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="item in transferredAcivities" :key="item.order_id">
                            <b-th>{{ item.reference_no }}</b-th>
                            <b-td>{{ item.status }}</b-td>
                            <b-td><b-link :to="`/ams/activities/${item.order_id}`" target="_blank">link</b-link></b-td>
                        </b-tr>

                    </b-tbody>
                    <b-tfoot>
                        <b-tr>
                            <b-td colspan="7" variant="secondary" class="text-right">
                                Total Activities: <b>{{ transferredAcivities.length }}</b>
                            </b-td>
                        </b-tr>
                    </b-tfoot>



                </b-table-simple>
            </div>
            <b-button class="mt-3" block @click="closeTransfer">OK</b-button>
        </b-modal>
        <b-card class="inner-page p-3">
            <b-tabs align="center" card>
                <b-tab :title="$translate('transfer')" active><b-card-text>
                        <b-card class="form-sample mt-3" body-class="p-0" :title="title">
                            <b-card-body class="inventory_transfer p-0 mt-3">
                                <b-row v-show="isBulkItems">
                                    <b-col cols="12" md="4" class="dd">
                                        <label class="mb-3"><strong>{{
                                            $translate('warehouse_location')
                                                }}</strong></label>

                                        <b-form-select class="form-control" v-model="bulkWarehouse" :options="locations"
                                            required value-field="id" text-field="name" block>
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>
                                                    {{
                                                        $translate(
                                                            'select_location'
                                                        )
                                                    }}
                                                </b-form-select-option>
                                                <b-form-select-option :value="OFFICER" v-if="!isFromLossVault">
                                                    ({{
                                                        $translate('officer')
                                                    }})
                                                </b-form-select-option>
                                                <b-form-select-option :value="LOSS_VAULT" v-if="!isFromLossVault">
                                                    ({{
                                                        $translate(
                                                            'inventory_adjustment_warehouse'
                                                        )
                                                    }})
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="4" class="mt-3 mt-md-0 dd">
                                        <label class="mb-3"><strong>{{
                                            $translate('section_officer')
                                                }}</strong></label>
                                        <b-form-select class="form-control" v-model="bulkSectionOrOfficerId"
                                            value-field="id" :options="bulkSectionOfficerItems" text-field="name" block>
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>
                                                    {{
                                                        bulkWarehouse ==
                                                            LOSS_VAULT
                                                            ? $translate(
                                                                'inventory_adjustment_warehouse'
                                                            )
                                                            : $translate(
                                                                'please_select'
                                                            )
                                                    }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="4" class="mt-3 mt-md-0">
                                        <label class="mb-3"><strong>{{
                                            $translate('reason')
                                                }}</strong></label>
                                        <b-col>
                                            <b-form-input id="input-reason" v-model="bulkReason" :placeholder="$translate('enter_reason')
                                                " block>
                                            </b-form-input>
                                        </b-col>
                                    </b-col>
                                    <b-col class="text-center mt-3">
                                        <b-button id="apply-to-all-btn" @click="applyAll()" size="fw" :to="``"
                                            variant="info" align="center">
                                            {{ $translate('apply_to_all') }}
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3" align-h="center">
                                    <div class="form-check px-0">
                                        <label class="form-check-label">
                                            <input type="checkbox" id="checkbox-isFromLossVault"
                                                v-model="isFromLossVault" name="checkbox-isFromLossVault" :value="true"
                                                :unchecked-value="false" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="checkbox-isFromLossVault" class="px-2"><strong>{{
                                        $translate('from_external_source')
                                            }}</strong></label>
                                </b-row>
                                <b-col class="overflow-auto w-100 mt-4">
                                    <b-form class="p-0" @submit.stop.prevent="onSubmit">
                                        <b-table v-model="tabledata" :key="serialNo" :fields="itemFields" striped hover
                                            responsive :items="processedTransferItems" class="mt-3">
                                            <template #cell(product_name)="{ item }">
                                                <label>{{ item.name }}</label>
                                            </template>
                                            <template #cell(item_code)="{ item }">
                                                <label>{{
                                                    item.ext_reference_code
                                                    }}</label>
                                            </template>
                                            <template #cell(uom)="{ item }">
                                                <label>{{ item.uom }}</label>
                                            </template>
                                            <template #cell(quantity_on_hand)="{
                                                item,
                                            }">
                                                <label>{{
                                                    item.section.quantity_on_hand || 0,
                                                    }}</label>
                                            </template>
                                            <template #cell(to_qty)="{ index, item }">
                                                <b-form-input :disabled="!isFromLossVault &&
                                                    !item.section
                                                    " required type="number" min="0" v-model="toQuantityData[index]
                                                        " class="form-control"></b-form-input> </template>,

                                            <template #cell(from)="{ item }">
                                                <div v-html="getInventoryLocation(item)">
                                                </div>
                                            </template>
                                            <template #cell(tolocation)="{
                                                item,
                                                index,
                                            }">
                                                <b-col class="dd">
                                                    <b-form-select class="form-control" v-model="locationData[index]
                                                        " :options="locations" required value-field="id"
                                                        text-field="name" block :disabled="!isFromLossVault &&
                                                            !item.section

                                                            ">
                                                        <template #first>
                                                            <b-form-select-option :value="null" disabled>
                                                                {{
                                                                    $translate(
                                                                        'select_location'
                                                                    )
                                                                }}
                                                            </b-form-select-option>
                                                            <b-form-select-option v-if="
                                                                item.section &&
                                                                item.section
                                                                &&
                                                                !item
                                                                    .section

                                                                    .is_officer
                                                            " :value="OFFICER">
                                                                ({{
                                                                    $translate(
                                                                        'Officer'
                                                                    )
                                                                }})
                                                            </b-form-select-option>
                                                            <b-form-select-option v-if="
                                                                item.section
                                                            " :value="LOSS_VAULT
                                                                ">
                                                                ({{
                                                                    $translate(
                                                                        'inventory_adjustment_warehouse'
                                                                    )
                                                                }})
                                                            </b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                </b-col>
                                            </template>

                                            <template #cell(tosection)="{
                                                index,
                                                item,
                                            }">
                                                <b-col class="dd">
                                                    <b-form-select class="form-control" v-model="sectionData[index]
                                                        " value-field="id" :options="fetchSection(index)
                                                            " text-field="name" block :disabled="!isFromLossVault &&
                                                                !item.section

                                                                ">
                                                        <template #first>
                                                            <b-form-select-option :value="null" disabled>
                                                                {{
                                                                    locationData[
                                                                        index
                                                                    ] ==
                                                                        LOSS_VAULT
                                                                        ? $translate(
                                                                            'inventory_adjustment_warehouse'
                                                                        )
                                                                        : $translate(
                                                                            'please_select'
                                                                        )
                                                                }}
                                                            </b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                </b-col>
                                            </template>

                                            <template #cell(reason)="{ index, item }">
                                                <b-form-input :disabled="!isFromLossVault &&
                                                    !item.section

                                                    " class="form-control" v-model="reasonData[index]" required
                                                    placeholder="Enter reason" :id="'input-reason-' + index
                                                        " value-field="id" text-field="name" block>
                                                </b-form-input>
                                            </template>
                                        </b-table>
                                        <div class="text-center mt-3">
                                            <b-button id="transfer-btn" size="fw" variant="info" type="submit"
                                                class="me-2" :disabled="submiting">
                                                {{
                                                    submiting
                                                        ? $translate(
                                                            'transfering'
                                                        )
                                                        : $translate('transfer')
                                                }}
                                            </b-button>
                                            <b-button id="cancel-label-btn" @click="cancel()" variant="info" size="fw">
                                                {{ $cancelLabel() }}
                                            </b-button>
                                        </div>
                                    </b-form>
                                </b-col>
                            </b-card-body>
                        </b-card>
                    </b-card-text></b-tab>
                <b-tab :title="$translate('transactions')"><b-card-text>
                        <ListTransactions :transferItems="transferItems" />
                    </b-card-text></b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import { capitalCase } from 'change-case'

import ListTransactions from './ListTransactions.vue'

export default {
    name: 'inventoryTransfer-transfer',
    props: ['title', 'transferItems', 'transferOrderTypes'],
    mixins: [popupMixins, permissionsMixins],
    components: { ListTransactions },
    data() {
        return {
            modalResultVisible: false,
            ////////////////////
            serialNo: 0,
            processedTransferItems: [],
            tabledata: [],
            isFromLossVault: false,

            submiting: false,
            locationData: [],
            toQuantityData: [],

            sectionData: [],
            reasonData: [],

            bulkReason: '',
            bulkSectionOrOfficerId: null,
            bulkWarehouse: null,
        }
    },

    mounted() {
        this.initData(this.isFromLossVault)
    },
    computed: {
        itemFields() {
            return [
                {
                    key: 'item_code',
                    label: this.$translate('item_code'),
                },
                {
                    key: 'product_name',
                    label: this.$translate('product_name'),
                },
                {
                    key: 'uom',
                    label: this.$translate('uom'),
                },
                {
                    key: 'quantity_on_hand',
                    label: this.$translate('qty_on_hand'),
                },
                {
                    key: 'to_qty',
                    label: this.$translate('qty_transfer'),
                    class: 'col-1',
                },
                {
                    key: 'From',
                    label: this.$translate('from_inventory_location'),
                },
                {
                    key: 'tolocation',
                    label: this.$translate('to_location'),
                },
                {
                    key: 'tosection',
                    label: this.$translate('To_section_Officer'),
                },
                {
                    key: 'reason',
                    label: this.$translate('reason'),
                },
            ]
        },

        LOSS_VAULT() {
            return 'loss-vault'
        },
        OFFICER() {
            return 'officer'
        },
        isBulkItems() {
            return this.processedTransferItems.length > 1
        },
        sectionItems() {
            return this.$store.state.masterItem
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse && x.sections.some(y => !y.is_officer)
            ) || []
        },

        rows() {
            return this.processedTransferItems.length
        },
        users() {
            return this.$store.getters['users/all_admin_users'].map(x => {
                x.name = x.first_name + ' ' + x.last_name
                return x
            })
        },
        bulkSectionOfficerItems() {
            const location_id = this.bulkWarehouse
            if (location_id == this.OFFICER) {
                return this.users
            }
            const data = (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
            return data
        }, //////////////////////////////
        transferredAcivities() {
            return this.$store.state.masterItem.transferredAcivities;
        }
    },
    watch: {
        isFromLossVault: function (val) {
            this.initData(val)
        },
    },
    methods: {
        initData(val) {
            console.log('changed;', val)
            this.processedTransferItems.length = 0
            if (!val) {
                this.processedTransferItems.push(...this.transferItems)
            } else {
                for (const item of this.transferItems) {
                    const idx = this.processedTransferItems.findIndex(
                        x => x.id == item.id
                    )
                    if (idx == -1) {
                        const pItem = { ...item }
                        pItem.section = {}
                        pItem.section.quantity_on_hand = item.total_quantity
                        this.processedTransferItems.push(pItem)
                    }
                }
            }

            this.$nextTick(() => {
                this.toQuantityData = [
                    ...Array(this.processedTransferItems.length).keys(),
                ].map(() => 0)
                this.locationData = [
                    ...Array(this.processedTransferItems.length).keys(),
                ].map(() => null)
                this.sectionData = [
                    ...Array(this.processedTransferItems.length).keys(),
                ].map(() => null)
                this.serialNo++
            })
        },

        capitalize(x) {
            return capitalCase(x)
        },
        getInventoryLocation(item) {
            console.log("getInventiorytLocation:", item)
            let data
            if (!item.section?.id) {
                data = this.isFromLossVault
                    ? this.$translate('external_source')
                    : ''
            } else if (item?.section?.is_officer) {
                data =
                    `<strong>${this.$translate('officer')}</strong>: ` +
                    (item.section &&
                        item.section.officers[0] &&
                        item.section.officers[0].first_name)
            } else {
                data =
                    item.section?.location?.name +
                    `:` +
                    item?.section?.name
            }

            return data
        },
        showReportDialog() {
            return this.$refs.reportsDialog.show()
        },
        cancel() {
            this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [])
        },
        applyAll() {
            if (this.bulkWarehouse) {
                for (let i = 0; i < this.processedTransferItems.length; i++) {
                    const { id: master_item_id, section } = this.processedTransferItems[i]

                    if (!this.isFromLossVault && !section) {
                        continue
                    }

                    const is_officer = !!section?.is_officer
                    const location_section_id = section?.id
                    this.$set(this.reasonData, i, this.bulkReason)
                    if (!(this.bulkWarehouse == this.OFFICER && is_officer) &&
                        !(is_officer && location_section_id == this.bulkSectionOrOfficerId)) {
                        this.$set(this.locationData, i, this.bulkWarehouse)
                        this.$set(this.sectionData, i, this.bulkSectionOrOfficerId)
                    }
                }
            }
        },
        fetchSection(index) {
            const location_id = this.locationData[index]
            if (location_id == this.OFFICER) {
                return this.users
            }
            const data = (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
            return data
        },
        async onSubmit() {
            try {
                this.submiting = true
                const orderData = {
                    orders: [],
                }
                console.log("this.processedTransferItems", this.processedTransferItems)
                for (let index = 0; index < this.processedTransferItems.length; index++) {
                    const { id: master_item_id, section } = this.processedTransferItems[index]
                    console.log("master_item_id ...................:", master_item_id)

                    if (!this.isFromLossVault && !section) {
                        continue
                    }

                    const quantity = parseInt(this.toQuantityData[index])
                    if (quantity <= 0) continue
                    const order = { master_item_id, quantity }
                    //////from
                    const is_officer = !!section?.is_officer
                    if (!section) {
                        order.from_section_id = null
                        order.from_officer_id = null
                    } else if (!is_officer) {
                        order.from_section_id = section?.id
                        order.from_officer_id = null
                    } else {
                        order.from_officer_id = section?.officers[0].id
                        order.from_section_id = null
                    }

                    if (this.locationData[index] == this.LOSS_VAULT) {
                        order.to_section_id = null
                        order.to_officer_id = null
                    } else if (this.locationData[index] == this.OFFICER) {
                        order.to_section_id = null
                        order.to_officer_id = this.sectionData[index]
                    } else {
                        order.to_section_id = this.sectionData[index]
                        order.to_officer_id = null
                    }

                    console.log('orderData--order--:', order)

                    if (order.from_officer_id && order.to_officer_id) {
                        continue
                    }

                    console.log('orderData--order2--:', order)

                    if (
                        order.from_section_id == null &&
                        order.from_officer_id == null &&
                        order.to_section_id == null &&
                        order.to_officer_id == null
                    ) {
                        continue
                    }

                    if (order.from_section_id && order.from_section_id == order.to_section_id) {
                        continue
                    }

                    const {
                        sectionSection,
                        sectionOfficer,
                        sectionLoss,
                        officerLoss,
                        officerSection,
                        lossSection,
                    } = this.transferOrderTypes

                    if (
                        order.from_section_id &&
                        !order.from_officer_id &&
                        order.to_section_id &&
                        !order.to_officer_id
                    ) {
                        order.order_type_id = sectionSection
                    } else if (
                        order.from_section_id &&
                        !order.from_officer_id &&
                        !order.to_section_id &&
                        order.to_officer_id
                    ) {
                        console.log("what dis:", sectionOfficer)
                        order.order_type_id = sectionOfficer
                    } else if (
                        order.from_section_id &&
                        !order.from_officer_id &&
                        !order.to_section_id &&
                        !order.to_officer_id
                    ) {

                        order.order_type_id = sectionLoss
                    } else if (
                        !order.from_section_id &&
                        order.from_officer_id &&
                        !order.to_section_id &&
                        !order.to_officer_id
                    ) {
                        order.order_type_id = officerLoss
                    } else if (
                        !order.from_section_id &&
                        order.from_officer_id &&
                        order.to_section_id &&
                        !order.to_officer_id
                    ) {
                        order.order_type_id = officerSection
                    } else if (
                        !order.from_section_id &&
                        !order.from_officer_id &&
                        order.to_section_id &&
                        !order.to_officer_id
                    ) {
                        order.order_type_id = lossSection
                    }

                    if (!order.order_type_id) {
                        console.log("Blowwwww", order)
                        throw new Error(
                            this.$translate('default_settings_error')
                        )
                    }

                    order.notes = this.reasonData[index]
                    orderData.orders.push(order)
                }

                console.log('orderData----:', orderData)
                const path = 'masterItem/transfer'
                await this.$store.dispatch(path, orderData)
                this.modalResultVisible = true;
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.submiting = false
            }
        },
        closeTransfer() {
            this.modalResultVisible = false;
            this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [])
            this.$emit('set-items', this.processedTransferItems.map(x => x.id))
        }
    },
}
</script>
